webpackJsonp([1],{

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) {
        s = '0' + s;
    }
    return s;
};

exports.default = {
    getQueryStringByName: function getQueryStringByName(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null) context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    formatDate: {

        format: function format(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function parse(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int);break;
                        case 'M':
                            _date.setMonth(_int - 1);break;
                        case 'd':
                            _date.setDate(_int);break;
                        case 'h':
                            _date.setHours(_int);break;
                        case 'm':
                            _date.setMinutes(_int);break;
                        case 's':
                            _date.setSeconds(_int);break;
                    }
                }
                return _date;
            }
            return null;
        }

    }

};

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var roleMap = exports.roleMap = {
  0: '审核不通过',
  1: '店员',
  2: '店长',
  3: '销售员'
};

var tzOrderStatusMap = exports.tzOrderStatusMap = {
  ACCEPTED: '已接受',
  CONSUMED: '已消费',
  CANCELED: '已取消',
  ABORT: '已退款',
  NEW_ORDER: '新订单'
};

var handleStatusMap = exports.handleStatusMap = {
  1: '已接受',
  2: '满房拒绝',
  3: '价格变动拒绝',
  '-1': '未处理',
  4: '已取消'
};

var settleMap = exports.settleMap = {
  1: '待审核',
  2: '审批通过',
  3: '审批拒绝'
};

var fromMap = exports.fromMap = {
  0: '合计',
  1: '同舟',
  2: '代理通',
  3: '同程',
  4: '飞猪'
};
var fromNameMap = exports.fromNameMap = {
  1: 'tzName',
  2: 'dltName',
  3: 'tcName',
  4: 'pigName'
};

/***/ }),

/***/ 1089:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1090:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1091:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1092:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1093:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1094:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1095:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1096:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1097:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1098:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1099:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1109:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1094)

var Component = __webpack_require__(36)(
  /* script */
  null,
  /* template */
  __webpack_require__(1130),
  /* scopeId */
  "data-v-56200035",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1110:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1089)

var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(1123),
  /* scopeId */
  "data-v-176a9f5c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1111:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1098)

var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(1136),
  /* scopeId */
  "data-v-9a1f7ef4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1112:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1092)

var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(1128),
  /* scopeId */
  "data-v-5399ff0f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1113:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1096)

var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(1134),
  /* scopeId */
  "data-v-6e15589b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1114:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1095)

var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(522),
  /* template */
  __webpack_require__(1131),
  /* scopeId */
  "data-v-57ee3253",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1115:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(1127),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1116:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1097)

var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(1135),
  /* scopeId */
  "data-v-8bb27998",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1117:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1090)

var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(1124),
  /* scopeId */
  "data-v-218d569d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1118:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(1133),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1119:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1099)

var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(1137),
  /* scopeId */
  "data-v-a3fd9602",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1120:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1093)

var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(1129),
  /* scopeId */
  "data-v-53cdc068",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1121:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(1132),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1122:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(1126),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1123:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n      " + _vm._s(_vm.collapsed ? "" : _vm.sysName) + "\n    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "tools",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.collapse.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  })])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('img', {
    attrs: {
      "src": this.sysUserAvatar
    }
  }), _vm._v(" " + _vm._s(_vm.sysUserName))]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_vm._v("我的消息")]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("设置")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [(!_vm.collapsed) ? _c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? [(!item.leaf) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.children[0].name))]) : _vm._e()] : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.collapsed) ? _c('ul', {
    ref: "menuCollapsed",
    staticClass: "el-menu el-menu-vertical-demo collapsed"
  }, _vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? _c('li', {
      staticClass: "el-submenu item"
    }, [(!item.leaf) ? [_c('div', {
      staticClass: "el-submenu__title",
      staticStyle: {
        "padding-left": "20px"
      },
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })]), _vm._v(" "), _c('ul', {
      staticClass: "el-menu submenu",
      class: 'submenu-hook-' + index,
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('li', {
        key: child.path,
        staticClass: "el-menu-item",
        class: _vm.$route.path == child.path ? 'is-active' : '',
        staticStyle: {
          "padding-left": "40px"
        },
        on: {
          "click": function($event) {
            return _vm.$router.push(child.path)
          }
        }
      }, [_vm._v("\n                " + _vm._s(child.name) + "\n              ")]) : _vm._e()
    }), 0)] : [_c('li', {
      staticClass: "el-submenu"
    }, [_c('div', {
      staticClass: "el-submenu__title el-menu-item",
      class: _vm.$route.path == item.children[0].path ? 'is-active' : '',
      staticStyle: {
        "padding-left": "20px",
        "height": "56px",
        "line-height": "56px",
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push(item.children[0].path)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })])])]], 2) : _vm._e()
  }), 0) : _vm._e()], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), (_vm.showOpenId) ? _c('h1', [_vm._v(_vm._s(_vm.showOpenId))]) : _vm._e()], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1124:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getOrders
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.createOrders
    }
  }, [_vm._v("新增订单")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orders,
      "highlight-current-row": "",
      "fixed": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "from",
      "width": "70",
      "label": "渠道",
      "formatter": function (row) { return (_vm.fromMap[row.from]); }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderId",
      "label": "订单ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "handleStatus",
      "label": "处理状态",
      "formatter": function (row) { return _vm.getHandleStatus(row); }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "hotel_id",
      "label": "酒店名",
      "formatter": function (row) { return row.hotel_id ?
        _vm.hotelMap[row.hotel_id][_vm.fromNameMap[row.from]] || _vm.hotelMap[row.hotel_id].tzName :
        '-'; }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "日期",
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('p', [_vm._v("\n          入住日期\n          " + _vm._s(_vm.fecha.format(new Date(s.row.checkInDate), "YYYY-MM-DD")) + "\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          离店日期\n          " + _vm._s(_vm.fecha.format(new Date(s.row.checkOutDate), "YYYY-MM-DD")) + "\n        ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(s.row.stay) + "晚")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(s.row.roomCount) + "间")]), _vm._v(" "), _c('p', [_vm._v("早餐 " + _vm._s(s.row.breakfirst || 0) + " 份")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "价格"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('p', [_vm._v("价格 " + _vm._s(s.row.price))]), _vm._v(" "), _c('p', [_vm._v("原价 " + _vm._s(s.row.floorPrice))]), _vm._v(" "), _c('p', [_vm._v("立减 " + _vm._s(s.row.discount))]), _vm._v(" "), _c('p', [_vm._v("利润 " + _vm._s(s.row.commission))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "guestName",
      "label": "客户名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "goodsName",
      "label": "房型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "结算方式",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('p', [_vm._v(_vm._s(_vm.getPay(s.row)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "note",
      "label": "备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("发送")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "价格",
      "prop": "price"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.price),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "price", $$v)
      },
      expression: "editForm.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原价",
      "prop": "floorPrice"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.floorPrice),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "floorPrice", $$v)
      },
      expression: "editForm.floorPrice"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "立减",
      "prop": "discount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.discount),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "discount", $$v)
      },
      expression: "editForm.discount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "酒店",
      "prop": "hotel_id"
    }
  }, [_c('el-select', {
    staticClass: "long-select",
    attrs: {
      "filterable": ""
    },
    on: {
      "change": function (hId) { return _vm.getPayByHotel(hId, 'editForm'); }
    },
    model: {
      value: (_vm.editForm.hotel_id),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "hotel_id", $$v)
      },
      expression: "editForm.hotel_id"
    }
  }, _vm._l((_vm.hotels), function(hotel, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": +hotel[0],
        "label": hotel[1][_vm.fromNameMap[_vm.editForm.from]] || hotel[1].tzName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "早餐",
      "prop": "breakfirst",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "早餐"
    },
    model: {
      value: (_vm.editForm.breakfirst),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "breakfirst", $$v)
      },
      expression: "editForm.breakfirst"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "note"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.note),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "note", $$v)
      },
      expression: "editForm.note"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "取消订单",
      "prop": "cancel"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.editForm.cancel),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "cancel", $$v)
      },
      expression: "editForm.cancel"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 0,
      "label": "否"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 1,
      "label": "取消"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算方式",
      "prop": "pay"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.editForm.pay),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "pay", $$v)
      },
      expression: "editForm.pay"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "日结"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 2,
      "label": "周结"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 3,
      "label": "月结"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "渠道",
      "prop": "from"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.addForm.from),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "from", $$v)
      },
      expression: "addForm.from"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "同舟",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "代理通",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "同程",
      "value": 3
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "飞猪",
      "value": 4
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "酒店",
      "prop": "hotel_id",
      "required": ""
    }
  }, [_c('el-select', {
    staticClass: "long-select",
    attrs: {
      "filterable": ""
    },
    on: {
      "change": function (hId) { return _vm.getPayByHotel(hId, 'addForm'); }
    },
    model: {
      value: (_vm.addForm.hotel_id),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "hotel_id", $$v)
      },
      expression: "addForm.hotel_id"
    }
  }, _vm._l((_vm.hotels), function(hotel, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": +hotel[0],
        "label": hotel[1][_vm.fromNameMap[_vm.addForm.from]] || hotel[1].tzName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原价",
      "prop": "floorPrice",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "酒店原价"
    },
    model: {
      value: (_vm.addForm.floorPrice),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "floorPrice", $$v)
      },
      expression: "addForm.floorPrice"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "价格",
      "prop": "price",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "价格"
    },
    model: {
      value: (_vm.addForm.price),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "price", $$v)
      },
      expression: "addForm.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "立减",
      "prop": "discount",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "立减"
    },
    model: {
      value: (_vm.addForm.discount),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "discount", $$v)
      },
      expression: "addForm.discount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "房型",
      "prop": "goodsName",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "房型"
    },
    model: {
      value: (_vm.addForm.goodsName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "goodsName", $$v)
      },
      expression: "addForm.goodsName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客人姓名",
      "prop": "guestName",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "客人姓名"
    },
    model: {
      value: (_vm.addForm.guestName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "guestName", $$v)
      },
      expression: "addForm.guestName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "入住离开日期",
      "required": ""
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "入住日期",
      "end-placeholder": "离店日期"
    },
    model: {
      value: (_vm.addForm.dates),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "dates", $$v)
      },
      expression: "addForm.dates"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "房间数",
      "prop": "roomCount",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "房间数"
    },
    model: {
      value: (_vm.addForm.roomCount),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "roomCount", $$v)
      },
      expression: "addForm.roomCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "早餐",
      "prop": "breakfirst",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "早餐"
    },
    model: {
      value: (_vm.addForm.breakfirst),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "breakfirst", $$v)
      },
      expression: "addForm.breakfirst"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算方式",
      "prop": "pay"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.addForm.pay),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "pay", $$v)
      },
      expression: "addForm.pay"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "日结"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 2,
      "label": "周结"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 3,
      "label": "月结"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1125:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1126:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),

/***/ 1127:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "选择平台"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.key),
      callback: function($$v) {
        _vm.key = $$v
      },
      expression: "key"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "0",
      "label": "同舟"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "1",
      "label": "代理通"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "2",
      "label": "同程"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "3",
      "label": "飞猪"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "cookie值"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入cookie值"
    },
    model: {
      value: (_vm.cookie),
      callback: function($$v) {
        _vm.cookie = $$v
      },
      expression: "cookie"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1128:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getUsers
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), (_vm.isSuperAdmin) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "用户名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "role",
      "label": "角色",
      "formatter": _vm.formatRole
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "openId",
      "label": "openId",
      "width": "400"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "不填则不变",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.password),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "password", $$v)
      },
      expression: "editForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角色",
      "prop": "role"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.editForm.role),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "role", $$v)
      },
      expression: "editForm.role"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "超级管理员",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "普通管理员",
      "value": 1
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "openId",
      "prop": "openId"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.openId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "openId", $$v)
      },
      expression: "editForm.openId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.password),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "password", $$v)
      },
      expression: "addForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角色",
      "prop": "role"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.addForm.role),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "role", $$v)
      },
      expression: "addForm.role"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "超级管理员",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "普通管理员",
      "value": 1
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "openId",
      "prop": "openId"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.openId),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "openId", $$v)
      },
      expression: "addForm.openId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1129:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "日期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.search.checkInRange),
      callback: function($$v) {
        _vm.$set(_vm.search, "checkInRange", $$v)
      },
      expression: "search.checkInRange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getOrders
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-tabs', {
    on: {
      "tab-click": _vm.onTabChange
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "日级数据",
      "name": "date"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "月级数据",
      "name": "month"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "年级数据",
      "name": "year"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orders,
      "highlight-current-row": "",
      "fixed": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "form",
      "width": "70",
      "label": "渠道",
      "formatter": function (row) { return (_vm.fromMap[row.form]); }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "check_in_date",
      "label": "入住日期"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderCount",
      "label": "订单数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "总价"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "commission",
      "label": "总佣金"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "roomStay",
      "label": "间夜数"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1130:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ }),

/***/ 1131:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "chart-container"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartColumn"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartBar"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartLine"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartPie"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "href": "http://echarts.baidu.com/examples.html",
      "target": "_blank"
    }
  }, [_vm._v("more>>")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1132:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.search
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "酒店"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "选择酒店",
      "clearable": ""
    },
    model: {
      value: (_vm.search.hotel_id),
      callback: function($$v) {
        _vm.$set(_vm.search, "hotel_id", $$v)
      },
      expression: "search.hotel_id"
    }
  }, _vm._l((_vm.hotels), function(item) {
    return _c('el-option', {
      key: item[0],
      attrs: {
        "value": item[0],
        "label": item[1].tzName || item[1].dltName
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item[1].tzName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(item[1].dltName))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "日期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.search.range),
      callback: function($$v) {
        _vm.$set(_vm.search, "range", $$v)
      },
      expression: "search.range"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "房型名"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.search.name),
      callback: function($$v) {
        _vm.$set(_vm.search, "name", $$v)
      },
      expression: "search.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "早餐数"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "clearable": ""
    },
    model: {
      value: (_vm.search.breakfirst),
      callback: function($$v) {
        _vm.$set(_vm.search, "breakfirst", $$v)
      },
      expression: "search.breakfirst"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getTpls
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增价格")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleBatchEdit
    }
  }, [_vm._v("批量修改")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleBatchDel
    }
  }, [_vm._v("批量删除")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "酒店"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "选择酒店",
      "clearable": ""
    },
    model: {
      value: (_vm.addForm.hotel_id),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "hotel_id", $$v)
      },
      expression: "addForm.hotel_id"
    }
  }, _vm._l((_vm.hotels), function(item) {
    return _c('el-option', {
      key: item[0],
      attrs: {
        "value": item[0],
        "label": item[1].tzName || item[1].dltName
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item[1].tzName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(item[1].dltName))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择日期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "placeholder": "选择日期范围",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.addForm.range),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "range", $$v)
      },
      expression: "addForm.range"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "适用星期"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.addForm.weekdays),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "weekdays", $$v)
      },
      expression: "addForm.weekdays"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "周一"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 2,
      "label": "周二"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 3,
      "label": "周三"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 4,
      "label": "周四"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 5,
      "label": "周五"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 6,
      "label": "周六"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 0,
      "label": "周日"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "房型"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入房型"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "早餐数"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "输入早餐数"
    },
    model: {
      value: (_vm.addForm.breakfirst),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "breakfirst", $$v)
      },
      expression: "addForm.breakfirst"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "价格"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "输入价格"
    },
    model: {
      value: (_vm.addForm.price),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "price", $$v)
      },
      expression: "addForm.price"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "批量删除",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.batchDeleteVisible),
      callback: function($$v) {
        _vm.batchDeleteVisible = $$v
      },
      expression: "batchDeleteVisible"
    }
  }, [_c('el-form', {
    ref: "batchDeleteForm",
    attrs: {
      "model": _vm.batchDeleteForm,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "酒店",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "选择酒店",
      "clearable": ""
    },
    model: {
      value: (_vm.batchDeleteForm.hotel_id),
      callback: function($$v) {
        _vm.$set(_vm.batchDeleteForm, "hotel_id", $$v)
      },
      expression: "batchDeleteForm.hotel_id"
    }
  }, _vm._l((_vm.hotels), function(item) {
    return _c('el-option', {
      key: item[0],
      attrs: {
        "value": item[0],
        "label": item[1].tzName || item[1].dltName
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item[1].tzName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(item[1].dltName))])])
  }), 1), _vm._v(" "), _c('span', [_vm._v("必须选择酒店")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择日期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "placeholder": "选择日期范围",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.batchDeleteForm.range),
      callback: function($$v) {
        _vm.$set(_vm.batchDeleteForm, "range", $$v)
      },
      expression: "batchDeleteForm.range"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "适用星期"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.batchDeleteForm.weekdays),
      callback: function($$v) {
        _vm.$set(_vm.batchDeleteForm, "weekdays", $$v)
      },
      expression: "batchDeleteForm.weekdays"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "周一"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 2,
      "label": "周二"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 3,
      "label": "周三"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 4,
      "label": "周四"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 5,
      "label": "周五"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 6,
      "label": "周六"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 0,
      "label": "周日"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "房型"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入房型"
    },
    model: {
      value: (_vm.batchDeleteForm.name),
      callback: function($$v) {
        _vm.$set(_vm.batchDeleteForm, "name", $$v)
      },
      expression: "batchDeleteForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "早餐数"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "number",
      "placeholder": "输入早餐数"
    },
    model: {
      value: (_vm.batchDeleteForm.breakfirst),
      callback: function($$v) {
        _vm.$set(_vm.batchDeleteForm, "breakfirst", $$v)
      },
      expression: "batchDeleteForm.breakfirst"
    }
  }), _vm._v(" "), _c('span', [_vm._v("早餐数为0代表无早，删除不填代表不作为搜索条件")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "价格"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "输入价格"
    },
    model: {
      value: (_vm.batchDeleteForm.price),
      callback: function($$v) {
        _vm.$set(_vm.batchDeleteForm, "price", $$v)
      },
      expression: "batchDeleteForm.price"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.batchDeleteVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.batchDeleteSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "批量修改价格",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.batchEditVisible),
      callback: function($$v) {
        _vm.batchEditVisible = $$v
      },
      expression: "batchEditVisible"
    }
  }, [_c('el-form', {
    ref: "batchEditForm",
    attrs: {
      "model": _vm.batchEditForm,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "酒店",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "选择酒店",
      "clearable": ""
    },
    model: {
      value: (_vm.batchEditForm.hotel_id),
      callback: function($$v) {
        _vm.$set(_vm.batchEditForm, "hotel_id", $$v)
      },
      expression: "batchEditForm.hotel_id"
    }
  }, _vm._l((_vm.hotels), function(item) {
    return _c('el-option', {
      key: item[0],
      attrs: {
        "value": item[0],
        "label": item[1].tzName || item[1].dltName
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item[1].tzName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(item[1].dltName))])])
  }), 1), _vm._v(" "), _c('span', [_vm._v("必须选择酒店")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择日期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "placeholder": "选择日期范围",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.batchEditForm.range),
      callback: function($$v) {
        _vm.$set(_vm.batchEditForm, "range", $$v)
      },
      expression: "batchEditForm.range"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "适用星期"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.batchEditForm.weekdays),
      callback: function($$v) {
        _vm.$set(_vm.batchEditForm, "weekdays", $$v)
      },
      expression: "batchEditForm.weekdays"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "周一"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 2,
      "label": "周二"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 3,
      "label": "周三"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 4,
      "label": "周四"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 5,
      "label": "周五"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 6,
      "label": "周六"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 0,
      "label": "周日"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "房型"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入房型"
    },
    model: {
      value: (_vm.batchEditForm.name),
      callback: function($$v) {
        _vm.$set(_vm.batchEditForm, "name", $$v)
      },
      expression: "batchEditForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "早餐数"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "number",
      "placeholder": "输入早餐数"
    },
    model: {
      value: (_vm.batchEditForm.breakfirst),
      callback: function($$v) {
        _vm.$set(_vm.batchEditForm, "breakfirst", $$v)
      },
      expression: "batchEditForm.breakfirst"
    }
  }), _vm._v(" "), _c('span', [_vm._v("早餐数为0代表无早，删除不填代表不作为搜索条件")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "价格"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "输入价格"
    },
    model: {
      value: (_vm.batchEditForm.price),
      callback: function($$v) {
        _vm.$set(_vm.batchEditForm, "price", $$v)
      },
      expression: "batchEditForm.price"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.batchEditVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.batchEditSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "酒店"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "placeholder": _vm.hotelMap[_vm.editForm.hotel_id] && _vm.hotelMap[_vm.editForm.hotel_id].tzName
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择日期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "align": "right",
      "disabled": "",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.editForm.tpl_date),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "tpl_date", $$v)
      },
      expression: "editForm.tpl_date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "房型"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入房型"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "早餐数"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "输入早餐数"
    },
    model: {
      value: (_vm.editForm.breakfirst),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "breakfirst", $$v)
      },
      expression: "editForm.breakfirst"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "价格"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "输入价格"
    },
    model: {
      value: (_vm.editForm.price),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "price", $$v)
      },
      expression: "editForm.price"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), (_vm.tableType === 1) ? [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tpls,
      "highlight-current-row": "",
      "fixed": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "300",
      "prop": "hotel_id",
      "label": "酒店名",
      "formatter": function (row) { return row.hotel_id ?
        (_vm.hotelMap[row.hotel_id] &&
          _vm.hotelMap[row.hotel_id][
            _vm.fromNameMap[row.from] || 'tzName'
          ]) ||
        '-' :
        '-'; }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "prop": "name",
      "label": "房型名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "80",
      "prop": "breakfirst",
      "label": "早餐"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "tpl_date",
      "label": "日期",
      "formatter": function (row) { return _vm.formatDate(row); }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "price",
      "label": "价格"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.row.id)
            }
          }
        }, [_vm._v("删除")])]
      }
    }], null, false, 1191692484)
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)] : _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('el-collapse', _vm._l((Object.keys(_vm.listRes)), function(d) {
    return _c('el-collapse-item', {
      key: d,
      attrs: {
        "title": d
      }
    }, [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.listRes[d],
        "highlight-current-row": "",
        "fixed": ""
      }
    }, [_c('el-table-column', {
      attrs: {
        "width": "300",
        "prop": "hotel_id",
        "label": "酒店名",
        "formatter": function (row) { return row.hotel_id ?
          (_vm.hotelMap[row.hotel_id] &&
            _vm.hotelMap[row.hotel_id][
              _vm.fromNameMap[row.from] || 'tzName'
            ]) ||
          '-' :
          '-'; }
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "200",
        "prop": "name",
        "label": "房型名"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "80",
        "prop": "breakfirst",
        "label": "早餐"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "150",
        "prop": "tpl_date",
        "label": "日期",
        "formatter": function (row) { return _vm.formatDate(row); }
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "150",
        "prop": "price",
        "label": "价格"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "操作",
        "width": "200"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-button', {
            attrs: {
              "size": "small",
              "type": "primary"
            },
            on: {
              "click": function($event) {
                return _vm.handleEdit(scope.$index, scope.row)
              }
            }
          }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
            attrs: {
              "size": "small",
              "type": "danger"
            },
            on: {
              "click": function($event) {
                return _vm.handleDel(scope.row.id)
              }
            }
          }, [_vm._v("删除")])]
        }
      }], null, true)
    })], 1)], 1)
  }), 1)], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1133:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单ID"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "订单ID"
    },
    model: {
      value: (_vm.search.orderId),
      callback: function($$v) {
        _vm.$set(_vm.search, "orderId", $$v)
      },
      expression: "search.orderId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单状态"
    }
  }, [_c('el-select', {
    staticStyle: {
      "{\n              width": "200"
    },
    attrs: {
      "multiple": "",
      "placeholder": "订单状态",
      "clearable": ""
    },
    model: {
      value: (_vm.search.handleStatus),
      callback: function($$v) {
        _vm.$set(_vm.search, "handleStatus", $$v)
      },
      expression: "search.handleStatus"
    }
  }, _vm._l((Object.entries(_vm.handleStatusMap)), function(item) {
    return _c('el-option', {
      key: item[0],
      attrs: {
        "value": item[0],
        "label": item[1]
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "酒店"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "选择酒店",
      "clearable": ""
    },
    model: {
      value: (_vm.search.hotel_id),
      callback: function($$v) {
        _vm.$set(_vm.search, "hotel_id", $$v)
      },
      expression: "search.hotel_id"
    }
  }, _vm._l((_vm.hotels), function(item) {
    return _c('el-option', {
      key: item[0],
      attrs: {
        "value": item[0],
        "label": item[1].tzName || item[1].dltName
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item[1].tzName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(item[1].dltName))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "入住日期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.search.checkInRange),
      callback: function($$v) {
        _vm.$set(_vm.search, "checkInRange", $$v)
      },
      expression: "search.checkInRange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "离店日期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.search.checkOutRange),
      callback: function($$v) {
        _vm.$set(_vm.search, "checkOutRange", $$v)
      },
      expression: "search.checkOutRange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "入住人姓名"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.search.guestName),
      callback: function($$v) {
        _vm.$set(_vm.search, "guestName", $$v)
      },
      expression: "search.guestName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "渠道"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "选择渠道",
      "clearable": ""
    },
    model: {
      value: (_vm.search.from),
      callback: function($$v) {
        _vm.$set(_vm.search, "from", $$v)
      },
      expression: "search.from"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "同舟"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 2,
      "label": "代理通"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 3,
      "label": "同程"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 4,
      "label": "飞猪"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算方式",
      "prop": "pay"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.search.pay),
      callback: function($$v) {
        _vm.$set(_vm.search, "pay", $$v)
      },
      expression: "search.pay"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "日结"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 2,
      "label": "周结"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 3,
      "label": "月结"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "备注"
    },
    model: {
      value: (_vm.search.note),
      callback: function($$v) {
        _vm.$set(_vm.search, "note", $$v)
      },
      expression: "search.note"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getOrders
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getExcel
    }
  }, [_vm._v("导出excel")])], 1)], 1)], 1), _vm._v(" "), _c('p', [_vm._v("总价格:" + _vm._s(_vm.totalPrice) + ", 总利润" + _vm._s(_vm.totalCommission) + ", 总间夜数" + _vm._s(_vm.totalRoomCount) + " ")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orders,
      "highlight-current-row": "",
      "fixed": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "from",
      "width": "70",
      "label": "渠道",
      "formatter": function (row) { return (_vm.fromMap[row.from]); }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "handleStatus",
      "label": "处理状态",
      "width": "100",
      "formatter": function (row) { return _vm.getHandleStatus(row); }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "hotel_id",
      "label": "酒店名",
      "formatter": function (row) { return row.hotel_id ?
        (_vm.hotelMap[row.hotel_id] && _vm.hotelMap[row.hotel_id][_vm.fromNameMap[row.from] || 'tzName']) || '-' :
        '-'; }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "日期,间夜",
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('p', [_vm._v("\n          入住日期\n          " + _vm._s(_vm.fecha.format(new Date(s.row.checkInDate), "YYYY-MM-DD")) + "\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          离店日期\n          " + _vm._s(_vm.fecha.format(new Date(s.row.checkOutDate), "YYYY-MM-DD")) + "\n        ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(s.row.stay) + "晚")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(s.row.roomCount) + "间")]), _vm._v(" "), _c('p', [_vm._v("早餐 " + _vm._s(s.row.breakfirst || 0) + " 份")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "价格",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('p', [_vm._v("价格 " + _vm._s(s.row.price))]), _vm._v(" "), _c('p', [_vm._v("原价 " + _vm._s(s.row.floorPrice))]), _vm._v(" "), _c('p', [_vm._v("立减 " + _vm._s(s.row.discount))]), _vm._v(" "), _c('p', [_vm._v("利润 " + _vm._s(s.row.commission))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "guestName",
      "label": "客户名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "goodsName",
      "label": "房型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "结算方式",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('p', [_vm._v(_vm._s(_vm.getPay(s.row)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "note",
      "label": "备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.handleStatus) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleSend(scope.$index, scope.row)
            }
          }
        }, [_vm._v("发送")]) : _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("重新编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.row.id)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单状态",
      "prop": "handleStatus"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "订单状态",
      "clearable": ""
    },
    model: {
      value: (_vm.editForm.handleStatus),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "handleStatus", $$v)
      },
      expression: "editForm.handleStatus"
    }
  }, _vm._l((Object.entries(_vm.handleStatusMap).filter(
    function (item) { return item[0] != -1; }
  )), function(item) {
    return _c('el-option', {
      key: item[0],
      attrs: {
        "value": item[0],
        "label": item[1]
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "价格",
      "prop": "price"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.price),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "price", $$v)
      },
      expression: "editForm.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原价",
      "prop": "floorPrice"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.floorPrice),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "floorPrice", $$v)
      },
      expression: "editForm.floorPrice"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "立减",
      "prop": "discount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.discount),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "discount", $$v)
      },
      expression: "editForm.discount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "酒店",
      "prop": "hotel_id"
    }
  }, [_c('el-select', {
    staticClass: "long-select",
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.editForm.hotel_id),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "hotel_id", $$v)
      },
      expression: "editForm.hotel_id"
    }
  }, _vm._l((_vm.hotels), function(hotel, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": +hotel[0],
        "label": hotel[1][_vm.fromNameMap[_vm.editForm.from]] || hotel[1].tzName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "send",
      "label": "是否发送酒店"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.editForm.send),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "send", $$v)
      },
      expression: "editForm.send"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "是",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "否",
      "value": 0
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "早餐",
      "prop": "breakfirst",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "早餐"
    },
    model: {
      value: (_vm.editForm.breakfirst),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "breakfirst", $$v)
      },
      expression: "editForm.breakfirst"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算方式",
      "prop": "pay"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.editForm.pay),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "pay", $$v)
      },
      expression: "editForm.pay"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "日结"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 2,
      "label": "周结"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 3,
      "label": "月结"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "note"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.note),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "note", $$v)
      },
      expression: "editForm.note"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.password),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "password", $$v)
      },
      expression: "addForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角色",
      "prop": "role"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.addForm.role),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "role", $$v)
      },
      expression: "addForm.role"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "超级管理员",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "普通管理员",
      "value": 1
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1134:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getClerks
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "手机"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hotel_id",
      "label": "酒店"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function () { return _vm.showHotel(scope); }
          }
        }, [_vm._v("查看酒店")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "role",
      "label": "角色",
      "formatter": _vm.formatRole
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "mobile", $$v)
      },
      expression: "editForm.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角色",
      "prop": "role"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.editForm.role),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "role", $$v)
      },
      expression: "editForm.role"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "审核不通过",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "店员",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "店长",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "销售员",
      "value": 3
    }
  })], 1)], 1), _vm._v(" "), (_vm.editForm.role !== 3) ? _c('el-form-item', {
    attrs: {
      "label": "酒店",
      "prop": "hotel_id"
    }
  }, [_c('el-select', {
    staticClass: "long-select",
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.editForm.hotel_id),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "hotel_id", $$v)
      },
      expression: "editForm.hotel_id"
    }
  }, _vm._l((_vm.hotels), function(hotel) {
    return _c('el-option', {
      key: hotel.id,
      attrs: {
        "label": ((hotel.tzName ? hotel.tzName : '') + "--" + (hotel.dltName ? hotel.dltName : '')),
        "value": hotel.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.editForm.role === 3) ? _c('el-form-item', {
    attrs: {
      "label": "酒店",
      "prop": "hotel_ids"
    }
  }, [_c('el-select', {
    staticClass: "long-select",
    attrs: {
      "clearable": "",
      "multiple": "",
      "filterable": ""
    },
    model: {
      value: (_vm.editForm.hotel_ids),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "hotel_ids", $$v)
      },
      expression: "editForm.hotel_ids"
    }
  }, _vm._l((_vm.hotels), function(hotel) {
    return _c('el-option', {
      key: hotel.id,
      attrs: {
        "label": ((hotel.tzName ? hotel.tzName : '') + "--" + (hotel.dltName ? hotel.dltName : '')),
        "value": hotel.id
      }
    })
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "酒店名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.address),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "address", $$v)
      },
      expression: "addForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "银行卡",
      "prop": "bank_card"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.bank_card),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "bank_card", $$v)
      },
      expression: "addForm.bank_card"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看酒店"
    },
    model: {
      value: (_vm.modalVisible),
      callback: function($$v) {
        _vm.modalVisible = $$v
      },
      expression: "modalVisible"
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.roleHotels
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tzName",
      "label": "同舟酒店名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dltName",
      "label": "代理通酒店名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tcName",
      "label": "同程酒店名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pigName",
      "label": "飞猪酒店名"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.hideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1135:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "名称"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getHotels
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.hotels,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tzName",
      "width": "200px",
      "label": "同舟酒店名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dltName",
      "width": "200px",
      "label": "代理通酒店名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tcName",
      "width": "200px",
      "label": "同程酒店名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pigName",
      "width": "200px",
      "label": "飞猪酒店名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "结算方式",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_c('p', [_vm._v(_vm._s(_vm.getPay(s.row)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "width": "200px",
      "label": "地址"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "人员",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_vm._v("\n        " + _vm._s(s.row.clerks.map(function (i) { return ((_vm.roleMap[i.role]) + ":" + (i.name)); }).join("\n")) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "销售员",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(s) {
        return [_vm._v("\n        " + _vm._s(s.row.sales.map(function (i) { return ("" + (i.name)); }).join("\n")) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "同舟酒店名",
      "prop": "tzName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.tzName),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "tzName", $$v)
      },
      expression: "editForm.tzName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代理通酒店名",
      "prop": "dltName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.dltName),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "dltName", $$v)
      },
      expression: "editForm.dltName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "同程酒店名",
      "prop": "tcName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.tcName),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "tcName", $$v)
      },
      expression: "editForm.tcName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "飞猪酒店名",
      "prop": "tcName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.pigName),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "pigName", $$v)
      },
      expression: "editForm.pigName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.address),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "address", $$v)
      },
      expression: "editForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算方式",
      "prop": "pay"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.editForm.pay),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "pay", $$v)
      },
      expression: "editForm.pay"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "日结"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 2,
      "label": "周结"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 3,
      "label": "月结"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "同舟酒店名",
      "prop": "tzName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.tzName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "tzName", $$v)
      },
      expression: "addForm.tzName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代理通酒店名",
      "prop": "dltName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.dltName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "dltName", $$v)
      },
      expression: "addForm.dltName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "同程酒店名",
      "prop": "tcName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.tcName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "tcName", $$v)
      },
      expression: "addForm.tcName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "飞猪酒店名",
      "prop": "tcName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.pigName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "pigName", $$v)
      },
      expression: "addForm.pigName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.address),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "address", $$v)
      },
      expression: "addForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算方式",
      "prop": "pay"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.addForm.pay),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "pay", $$v)
      },
      expression: "addForm.pay"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "日结"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 2,
      "label": "周结"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 3,
      "label": "月结"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1136:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("系统登录")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "账号"
    },
    model: {
      value: (_vm.ruleForm2.account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "account", $$v)
      },
      expression: "ruleForm2.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-checkbox', {
    staticClass: "remember",
    attrs: {
      "checked": ""
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("记住密码")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2.apply(null, arguments)
      }
    }
  }, [_vm._v("登录")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1137:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    on: {
      "change": _vm.getSettles
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "待审批",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "审批通过",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "审批拒绝",
      "value": 3
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getSettles
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orders,
      "highlight-current-row": "",
      "fixed": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "creator",
      "label": "创建者"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180",
      "prop": "auditAmount",
      "label": "申请时间",
      "formatter": _vm.formatSettleTime
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "申请提现金额"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "note",
      "label": "提现备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "prop": "hotel_id",
      "label": "酒店名",
      "formatter": function (row) { return row.hotel_id ?
        row.from == 1 ?
        _vm.hotelMap[row.hotel_id].tzName :
        _vm.hotelMap[row.hotel_id].dltName :
        '-'; }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "auditStatus",
      "label": "审核状态",
      "formatter": _vm.getSettleStatus
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "auditAmount",
      "label": "审核金额"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "auditDetail",
      "label": "审核备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleExcel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("订单excel")]), _vm._v(" "), (scope.row.auditStatus < 2) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("审核")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "审核",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "审批状态",
      "prop": "hotel_id"
    }
  }, [_c('el-select', {
    staticClass: "long-select",
    model: {
      value: (_vm.editForm.auditStatus),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "auditStatus", $$v)
      },
      expression: "editForm.auditStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "审批通过",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "审批拒绝",
      "value": 3
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "审批金额",
      "prop": "auditAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.auditAmount),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "auditAmount", $$v)
      },
      expression: "editForm.auditAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "auditDetail"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.auditDetail),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "auditDetail", $$v)
      },
      expression: "editForm.auditDetail"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.password),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "password", $$v)
      },
      expression: "addForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角色",
      "prop": "role"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.addForm.role),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "role", $$v)
      },
      expression: "addForm.role"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "超级管理员",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "普通管理员",
      "value": 1
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1174:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1175:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 467:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Login = __webpack_require__(1111);

var _Login2 = _interopRequireDefault(_Login);

var _wechatLogin = __webpack_require__(1122);

var _wechatLogin2 = _interopRequireDefault(_wechatLogin);

var _ = __webpack_require__(1109);

var _2 = _interopRequireDefault(_);

var _Home = __webpack_require__(1110);

var _Home2 = _interopRequireDefault(_Home);

var _index = __webpack_require__(1112);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(1116);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(1113);

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__(1118);

var _index8 = _interopRequireDefault(_index7);

var _book = __webpack_require__(1117);

var _book2 = _interopRequireDefault(_book);

var _cookie = __webpack_require__(1115);

var _cookie2 = _interopRequireDefault(_cookie);

var _statistic = __webpack_require__(1120);

var _statistic2 = _interopRequireDefault(_statistic);

var _template = __webpack_require__(1121);

var _template2 = _interopRequireDefault(_template);

var _settle = __webpack_require__(1119);

var _settle2 = _interopRequireDefault(_settle);

var _echarts = __webpack_require__(1114);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
  path: '/login',
  component: _Login2.default,
  name: '',
  hidden: true
}, {
  path: '/wechat-login',
  component: _wechatLogin2.default,
  name: '',
  hidden: true
}, {
  path: '/404',
  component: _2.default,
  name: '',
  hidden: true
}, {
  path: '/',
  component: _Home2.default,
  name: '',
  iconCls: 'fa fa-address-card',
  leaf: true,
  children: [{ path: '/hotel', component: _index4.default, name: '酒店管理' }]
}, {
  path: '/',
  component: _Home2.default,
  name: '',
  iconCls: 'fa fa-address-card',
  leaf: true,
  children: [{ path: '/audit', component: _index6.default, name: '审核管理' }]
}, {
  path: '/',
  component: _Home2.default,
  name: '',
  iconCls: 'fa fa-address-card',
  leaf: true,
  children: [{ path: '/book', component: _book2.default, name: '预定管理' }]
}, {
  path: '/',
  component: _Home2.default,
  name: '',
  iconCls: 'fa fa-address-card',
  leaf: true,
  children: [{ path: '/order', component: _index8.default, name: '订单管理' }]
}, {
  path: '/',
  component: _Home2.default,
  name: '',
  iconCls: 'fa fa-address-card',
  leaf: true,
  children: [{ path: '/statistic', component: _statistic2.default, name: '数据统计' }]
}, {
  path: '/',
  component: _Home2.default,
  name: '',
  iconCls: 'fa fa-address-card',
  leaf: true,
  children: [{ path: '/template', component: _template2.default, name: '房态管理' }]
}, {
  path: '/',
  component: _Home2.default,
  name: '系统管理',
  iconCls: 'fa fa-address-card',
  leaf: false,
  children: [{ path: '/admin', component: _index2.default, name: '管理员' }, { path: '/cookie', component: _cookie2.default, name: '更新cookie' }]
}, {
  path: '*',
  hidden: true,
  redirect: { path: '/404' }
}];

exports.default = routes;

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(76);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(49);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(100);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(532);

var _actions2 = _interopRequireDefault(_actions);

var _getters = __webpack_require__(533);

var _getters2 = _interopRequireDefault(_getters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
  userInfo: { role: '', name: '', username: '' }
};
exports.default = new _vuex2.default.Store((0, _extends3.default)({}, _actions2.default, {
  getters: _getters2.default,
  state: state
}));

/***/ }),

/***/ 471:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 472:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1091)

var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(1125),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'app',
	components: {}
};

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _querystring = __webpack_require__(440);

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parseParam = function parseParam(_) {
  var search = window.location.href.split("?")[1];
  if (!search) return {};
  return _querystring2.default.parse(search);
};

exports.default = {
  data: function data() {
    return {
      sysName: "酒店管理系统",
      collapsed: false,
      sysUserName: "",
      sysUserAvatar: "",
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      showOpenId: ""
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      console.log("submit!");
    },
    handleopen: function handleopen() {},
    handleclose: function handleclose() {},

    handleselect: function handleselect(a, b) {},

    logout: function logout() {
      var _this = this;
      this.$confirm("确认退出吗?", "提示", {}).then(function () {
        sessionStorage.removeItem("user");
        _this.$router.push("/login");
      }).catch(function () {});
    },

    collapse: function collapse() {
      this.collapsed = !this.collapsed;
    },
    showMenu: function showMenu(i, status) {
      this.$refs.menuCollapsed.getElementsByClassName("submenu-hook-" + i)[0].style.display = status ? "block" : "none";
    }
  }
};

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(59);

var _nprogress = __webpack_require__(97);

var _nprogress2 = _interopRequireDefault(_nprogress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      logining: false,
      ruleForm2: {
        account: "",
        checkPass: ""
      },
      rules2: {
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        checkPass: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      checked: true
    };
  },

  methods: {
    handleReset2: function handleReset2() {
      this.$refs.ruleForm2.resetFields();
    },
    handleSubmit2: function handleSubmit2(ev) {
      var _this2 = this;

      var _this = this;
      this.$refs.ruleForm2.validate(function (valid) {
        if (valid) {
          _this2.logining = true;

          var loginParams = {
            name: _this2.ruleForm2.account,
            password: _this2.ruleForm2.checkPass
          };
          (0, _api.requestLogin)(loginParams).then(function (data) {
            _this2.logining = false;
            _nprogress2.default.done();
            _this2.$router.push({ path: "/hotel" });
          }).catch(function (e) {
            _this2.$message({
              message: e.response.data.message,
              type: "error"
            });
          }).finally(function (_) {
            _this2.logining = false;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(76);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(75);

var _assign2 = _interopRequireDefault(_assign);

var _util = __webpack_require__(101);

var _util2 = _interopRequireDefault(_util);

var _nprogress = __webpack_require__(97);

var _nprogress2 = _interopRequireDefault(_nprogress);

var _api = __webpack_require__(59);

var _vuex = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      filters: {
        name: ''
      },
      users: [],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [],

      editFormVisible: false,
      editLoading: false,
      editFormRules: {},

      editForm: {
        name: '',
        password: '',
        role: '',
        id: '',
        openId: ''
      },

      addFormVisible: false,
      addLoading: false,
      addFormRules: {
        name: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },

      addForm: {
        name: '',
        password: '',
        role: 1,
        openId: ''
      }
    };
  },

  methods: {
    formatRole: function formatRole(row, column) {
      return row.role == 0 ? '超级管理员' : '普通管理员';
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getUsers();
    },
    getUsers: function getUsers() {
      var _this = this;

      var para = {
        page: this.page
      };
      this.listLoading = true;
      _nprogress2.default.start();
      _api.adminApi.list(para).then(function (res) {
        _this.total = res.data.count;
        _this.users = res.data.rows;
        _this.listLoading = false;
        _nprogress2.default.done();
      });
    },

    handleDel: function handleDel(index, row) {
      var _this2 = this;

      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(function () {
        _this2.listLoading = true;
        _nprogress2.default.start();
        var para = { id: row.id };
        _api.adminApi.del(para).then(function (res) {
          _this2.listLoading = false;
          _nprogress2.default.done();
          _this2.$message({
            message: '删除成功',
            type: 'success'
          });
          _this2.getUsers();
        });
      }).catch(function () {});
    },

    handleEdit: function handleEdit(index, row) {
      this.editFormVisible = true;
      this.editForm = (0, _assign2.default)(this.editForm, row);
    },

    handleAdd: function handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        name: '',
        password: '',
        role: 0
      };
    },

    editSubmit: function editSubmit() {
      var _this3 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this3.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this3.editLoading = true;

            var para = (0, _assign2.default)({}, _this3.editForm);
            _api.adminApi.update(para).then(function (res) {
              _this3.editLoading = false;

              _this3.$message({
                message: '提交成功',
                type: 'success'
              });
              _this3.$refs['editForm'].resetFields();
              _this3.editFormVisible = false;
              _this3.getUsers();
            });
          });
        }
      });
    },

    addSubmit: function addSubmit() {
      var _this4 = this;

      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this4.$confirm('确认提交吗？', '提示', {}).then(function () {
            _this4.addLoading = true;

            var para = (0, _assign2.default)({}, _this4.addForm);

            _api.adminApi.add(para).then(function (res) {
              _this4.addLoading = false;

              _this4.$message({
                message: '提交成功',
                type: 'success'
              });
              _this4.$refs['addForm'].resetFields();
              _this4.addFormVisible = false;
              _this4.getUsers();
            });
          });
        }
      });
    },
    selsChange: function selsChange(sels) {
      this.sels = sels;
    },

    batchRemove: function batchRemove() {
      var _this5 = this;

      var ids = this.sels.map(function (item) {
        return item.id;
      }).toString();
      this.$confirm('确认删除选中记录吗？', '提示', {
        type: 'warning'
      }).then(function () {
        _this5.listLoading = true;

        var para = { ids: ids };
        batchRemoveUser(para).then(function (res) {
          _this5.listLoading = false;

          _this5.$message({
            message: '删除成功',
            type: 'success'
          });
          _this5.getUsers();
        });
      }).catch(function () {});
    }
  },
  mounted: function mounted() {
    this.getUsers();
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getUserInfo', 'isSuperAdmin']))
};

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(75);

var _assign2 = _interopRequireDefault(_assign);

var _util = __webpack_require__(101);

var _util2 = _interopRequireDefault(_util);

var _nprogress = __webpack_require__(97);

var _nprogress2 = _interopRequireDefault(_nprogress);

var _api = __webpack_require__(59);

var _constant = __webpack_require__(102);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      filters: {
        name: ""
      },
      hotels: [],
      users: [],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [],

      editFormVisible: false,
      editLoading: false,
      editFormRules: {},

      editForm: {
        name: "",
        mobile: "",
        hotel_id: "",
        role: "",
        hotel_ids: [],
        id: ""
      },

      addFormVisible: false,
      addLoading: false,
      addFormRules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        bank_card: [{ required: true, message: "请输入银行卡信息", trigger: "blur" }]
      },

      addForm: {
        name: "",
        address: "",
        bank_card: ""
      },
      modalVisible: false,
      roleHotels: []
    };
  },

  methods: {
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getClerks();
    },
    getHotels: function getHotels() {
      var _this = this;

      var para = {
        type: "all"
      };
      _nprogress2.default.start();
      _api.hotelApi.list(para).then(function (res) {
        _this.hotels = res.data.rows;
        _this.listLoading = false;
        _nprogress2.default.done();
      });
    },
    formatHotel: function formatHotel(row) {
      var _this2 = this;

      if (row.role === 3) {
        return row.hotel_ids.reduce(function (prev, hotel_id) {
          var found = _this2.hotels.find(function (_ref) {
            var id = _ref.id;
            return id === hotel_id;
          });
          return prev + (found && found.tzName + "-" + found.dltName) + "；";
        }, "");
      }
      var found = this.hotels.find(function (_ref2) {
        var id = _ref2.id;
        return id === row.hotel_id;
      });

      return found && found.tzName + "-" + found.dltName || "-";
    },
    showHotel: function showHotel(scope) {
      var row = scope.row;
      if (row.role === 3) {
        this.roleHotels = this.hotels.filter(function (i) {
          return row.hotel_ids.includes(i.id);
        });
      }
      var found = this.hotels.find(function (_ref3) {
        var id = _ref3.id;
        return id === row.hotel_id;
      });
      if (found) {
        this.roleHotels = [found];
      }
      this.modalVisible = true;
    },
    hideModal: function hideModal() {
      this.roleHotels = [];
      this.modalVisible = false;
    },
    formatRole: function formatRole(row) {
      return _constant.roleMap[row.role];
    },
    getClerks: function getClerks() {
      var _this3 = this;

      var para = {
        page: this.page
      };
      this.listLoading = true;
      _nprogress2.default.start();
      _api.auditApi.list(para).then(function (res) {
        _this3.total = res.data.count;
        _this3.users = res.data.rows;
        console.log(res.data.rows);
        _this3.listLoading = false;
        _nprogress2.default.done();
      });
    },

    handleDel: function handleDel(index, row) {
      var _this4 = this;

      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning"
      }).then(function () {
        _this4.listLoading = true;
        _nprogress2.default.start();
        var para = { id: row.id };
        _api.auditApi.del(para).then(function (res) {
          _this4.listLoading = false;
          _nprogress2.default.done();
          _this4.$message({
            message: "删除成功",
            type: "success"
          });
          _this4.getClerks();
        });
      }).catch(function () {});
    },

    handleEdit: function handleEdit(index, row) {
      this.editFormVisible = true;
      this.editForm = (0, _assign2.default)(this.editForm, row);
    },

    handleAdd: function handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        name: "",
        address: "",
        bank_card: ""
      };
    },

    editSubmit: function editSubmit() {
      var _this5 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this5.$confirm("确认提交吗？", "提示", {}).then(function () {
            _this5.editLoading = true;
            var _editForm = _this5.editForm,
                id = _editForm.id,
                hotel_id = _editForm.hotel_id,
                mobile = _editForm.mobile,
                role = _editForm.role,
                hotel_ids = _editForm.hotel_ids;

            var para = { id: id, hotel_id: hotel_id, mobile: mobile, role: role, hotel_ids: hotel_ids };
            _api.auditApi.update(para).then(function (res) {
              _this5.editLoading = false;

              _this5.$message({
                message: "提交成功",
                type: "success"
              });
              _this5.$refs["editForm"].resetFields();
              _this5.editFormVisible = false;
              _this5.getClerks();
            });
          });
        }
      });
    },

    addSubmit: function addSubmit() {
      var _this6 = this;

      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this6.$confirm("确认提交吗？", "提示", {}).then(function () {
            _this6.addLoading = true;

            var para = (0, _assign2.default)({}, _this6.addForm);

            _api.hotelApi.add(para).then(function (res) {
              _this6.addLoading = false;

              _this6.$message({
                message: "提交成功",
                type: "success"
              });
              _this6.$refs["addForm"].resetFields();
              _this6.addFormVisible = false;
              _this6.getHotels();
            });
          });
        }
      });
    },
    selsChange: function selsChange(sels) {
      this.sels = sels;
    },

    batchRemove: function batchRemove() {
      var _this7 = this;

      var ids = this.sels.map(function (item) {
        return item.id;
      }).toString();
      this.$confirm("确认删除选中记录吗？", "提示", {
        type: "warning"
      }).then(function () {
        _this7.listLoading = true;

        var para = { ids: ids };
        batchRemoveUser(para).then(function (res) {
          _this7.listLoading = false;

          _this7.$message({
            message: "删除成功",
            type: "success"
          });
          _this7.getHotels();
        });
      }).catch(function () {});
    }
  },
  mounted: function mounted() {
    this.getHotels();
    this.getClerks();
  }
};

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _echarts = __webpack_require__(784);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            chartColumn: null,
            chartBar: null,
            chartLine: null,
            chartPie: null
        };
    },


    methods: {
        drawColumnChart: function drawColumnChart() {
            this.chartColumn = _echarts2.default.init(document.getElementById('chartColumn'));
            this.chartColumn.setOption({
                title: { text: 'Column Chart' },
                tooltip: {},
                xAxis: {
                    data: ["衬衫", "羊毛衫", "雪纺衫", "裤子", "高跟鞋", "袜子"]
                },
                yAxis: {},
                series: [{
                    name: '销量',
                    type: 'bar',
                    data: [5, 20, 36, 10, 10, 20]
                }]
            });
        },
        drawBarChart: function drawBarChart() {
            this.chartBar = _echarts2.default.init(document.getElementById('chartBar'));
            this.chartBar.setOption({
                title: {
                    text: 'Bar Chart',
                    subtext: '数据来自网络'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    data: ['2011年', '2012年']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.01]
                },
                yAxis: {
                    type: 'category',
                    data: ['巴西', '印尼', '美国', '印度', '中国', '世界人口(万)']
                },
                series: [{
                    name: '2011年',
                    type: 'bar',
                    data: [18203, 23489, 29034, 104970, 131744, 630230]
                }, {
                    name: '2012年',
                    type: 'bar',
                    data: [19325, 23438, 31000, 121594, 134141, 681807]
                }]
            });
        },
        drawLineChart: function drawLineChart() {
            this.chartLine = _echarts2.default.init(document.getElementById('chartLine'));
            this.chartLine.setOption({
                title: {
                    text: 'Line Chart'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['邮件营销', '联盟广告', '搜索引擎']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    name: '邮件营销',
                    type: 'line',
                    stack: '总量',
                    data: [120, 132, 101, 134, 90, 230, 210]
                }, {
                    name: '联盟广告',
                    type: 'line',
                    stack: '总量',
                    data: [220, 182, 191, 234, 290, 330, 310]
                }, {
                    name: '搜索引擎',
                    type: 'line',
                    stack: '总量',
                    data: [820, 932, 901, 934, 1290, 1330, 1320]
                }]
            });
        },
        drawPieChart: function drawPieChart() {
            this.chartPie = _echarts2.default.init(document.getElementById('chartPie'));
            this.chartPie.setOption({
                title: {
                    text: 'Pie Chart',
                    subtext: '纯属虚构',
                    x: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎']
                },
                series: [{
                    name: '访问来源',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '60%'],
                    data: [{ value: 335, name: '直接访问' }, { value: 310, name: '邮件营销' }, { value: 234, name: '联盟广告' }, { value: 135, name: '视频广告' }, { value: 1548, name: '搜索引擎' }],
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }]
            });
        },
        drawCharts: function drawCharts() {
            this.drawColumnChart();
            this.drawBarChart();
            this.drawLineChart();
            this.drawPieChart();
        }
    },

    mounted: function mounted() {
        this.drawCharts();
    },
    updated: function updated() {
        this.drawCharts();
    }
};

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(59);

exports.default = {
  data: function data() {
    return {
      key: '0',
      cookie: ''
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      if (this.cookie) {
        _api.orderApi.cookie(this).then(function (r) {
          if (r.code == 0) {
            _this.$message.success('更新成功');
          } else {
            _this.$message.error('更新失败');
          }
        });
      }
    }
  }
};

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(75);

var _assign2 = _interopRequireDefault(_assign);

var _util = __webpack_require__(101);

var _util2 = _interopRequireDefault(_util);

var _nprogress = __webpack_require__(97);

var _nprogress2 = _interopRequireDefault(_nprogress);

var _api = __webpack_require__(59);

var _constant = __webpack_require__(102);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      roleMap: _constant.roleMap,
      filters: {
        name: ""
      },
      hotels: [],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [],

      editFormVisible: false,
      editLoading: false,

      editForm: {
        tzName: "",
        address: "",
        id: "",
        dltName: "",
        tcName: "",
        pay: "",
        pigName: ''
      },

      addFormVisible: false,
      addLoading: false,
      addFormRules: {
        tzName: [{ required: true, message: "请输入同舟平台名称", trigger: "blur" }],
        dltName: [{
          required: true,
          message: "请输入代理通平台名称",
          trigger: "blur"
        }],
        tcName: [{
          required: true,
          message: "请输入同程平台名称",
          trigger: "blur"
        }],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }]
      },
      editFormRules: {
        tzName: [{ required: true, message: "请输入同舟平台名称", trigger: "blur" }],
        dltName: [{
          required: true,
          message: "请输入代理通平台名称",
          trigger: "blur"
        }],
        tcName: [{
          required: true,
          message: "请输入同程平台名称",
          trigger: "blur"
        }],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }]
      },

      addForm: {
        tzName: "",
        dltName: "",
        tcName: "",
        address: "",
        pigName: ''
      }
    };
  },

  methods: {
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getHotels();
    },
    getPay: function getPay(row) {
      var e = {
        1: "日结",
        2: "周结",
        3: "月结"
      };
      return e[row.pay] || "-";
    },
    getHotels: function getHotels() {
      var _this = this;

      var para = {
        page: this.page,
        name: this.filters.name
      };
      this.listLoading = true;
      _nprogress2.default.start();
      _api.hotelApi.list(para).then(function (res) {
        _this.total = res.data.count;
        _this.hotels = res.data.rows;
        _this.listLoading = false;
        _nprogress2.default.done();
      });
    },

    handleDel: function handleDel(index, row) {
      var _this2 = this;

      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning"
      }).then(function () {
        _this2.listLoading = true;
        _nprogress2.default.start();
        var para = { id: row.id };
        _api.hotelApi.del(para).then(function (res) {
          _this2.listLoading = false;
          _nprogress2.default.done();
          _this2.$message({
            message: "删除成功",
            type: "success"
          });
          _this2.getHotels();
        });
      }).catch(function () {});
    },

    handleEdit: function handleEdit(index, row) {
      this.editFormVisible = true;
      this.editForm = (0, _assign2.default)(this.editForm, row);
    },

    handleAdd: function handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        name: "",
        address: "",
        tcName: "",
        pay: ""
      };
    },

    editSubmit: function editSubmit() {
      var _this3 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this3.$confirm("确认提交吗？", "提示", {}).then(function () {
            _this3.editLoading = true;

            var para = (0, _assign2.default)({}, _this3.editForm);
            _api.hotelApi.update(para).then(function (res) {
              _this3.$message({
                message: "提交成功",
                type: "success"
              });
              _this3.$refs["editForm"].resetFields();
              _this3.editFormVisible = false;
              _this3.getHotels();
            }).finally(function (_) {
              _this3.editLoading = false;
            });
          });
        }
      });
    },

    addSubmit: function addSubmit() {
      var _this4 = this;

      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this4.$confirm("确认提交吗？", "提示", {}).then(function () {
            _this4.addLoading = true;

            var para = (0, _assign2.default)({}, _this4.addForm);

            _api.hotelApi.add(para).then(function (res) {
              _this4.addLoading = false;

              _this4.$message({
                message: "提交成功",
                type: "success"
              });
              _this4.$refs["addForm"].resetFields();
              _this4.addFormVisible = false;
              _this4.getHotels();
            });
          });
        }
      });
    },
    selsChange: function selsChange(sels) {
      this.sels = sels;
    },

    batchRemove: function batchRemove() {
      var _this5 = this;

      var ids = this.sels.map(function (item) {
        return item.id;
      }).toString();
      this.$confirm("确认删除选中记录吗？", "提示", {
        type: "warning"
      }).then(function () {
        _this5.listLoading = true;

        var para = { ids: ids };
        batchRemoveUser(para).then(function (res) {
          _this5.listLoading = false;

          _this5.$message({
            message: "删除成功",
            type: "success"
          });
          _this5.getHotels();
        });
      }).catch(function () {});
    }
  },
  mounted: function mounted() {
    this.getHotels();
  },
  created: function created() {}
};

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(76);

var _extends3 = _interopRequireDefault(_extends2);

var _entries = __webpack_require__(149);

var _entries2 = _interopRequireDefault(_entries);

var _assign = __webpack_require__(75);

var _assign2 = _interopRequireDefault(_assign);

var _util = __webpack_require__(101);

var _util2 = _interopRequireDefault(_util);

var _nprogress = __webpack_require__(97);

var _nprogress2 = _interopRequireDefault(_nprogress);

var _api = __webpack_require__(59);

var _vuex = __webpack_require__(100);

var _fecha = __webpack_require__(174);

var _fecha2 = _interopRequireDefault(_fecha);

var _constant = __webpack_require__(102);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultAddform = {
  from: 1,
  hotel_id: null,
  floorPrice: 0,
  price: 0,
  discount: 0,
  checkInDate: "",
  checkOutDate: "",
  guestName: "",
  goodsName: "",
  stay: 1,
  roomCount: 1,
  breakfirst: 0,
  dates: []
};
exports.default = {
  data: function data() {
    return {
      fromNameMap: _constant.fromNameMap,
      fromMap: _constant.fromMap,
      stausMap: {},
      hotelMap: {},
      hotels: [],
      filters: {
        name: ""
      },
      orders: [],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [],

      editFormVisible: false,
      editLoading: false,
      editFormRules: {},

      editForm: {
        note: "",
        discount: 0,
        floorPrice: 0,
        price: 0,
        id: "",
        hotel_id: "",
        cancel: 0,
        breakfirst: 0,
        pay: "",
        from: 1
      },

      addFormVisible: false,
      addLoading: false,
      addFormRules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },

      addForm: {
        from: 1,
        hotel_id: null,
        floorPrice: 0,
        price: 0,
        discount: 0,
        checkInDate: "",
        checkOutDate: "",
        guestName: "",
        goodsName: "",
        stay: 1,
        roomCount: 1,
        breakfirst: 0,
        dates: [],
        pay: ""
      }
    };
  },

  methods: {
    getPayByHotel: function getPayByHotel(hotelId, form) {
      this[form].pay = this.hotelMap[hotelId] ? this.hotelMap[hotelId].pay : "";
    },

    formatRole: function formatRole(row, column) {
      return row.role == 0 ? "超级管理员" : "普通管理员";
    },
    getPay: function getPay(row) {
      var e = {
        1: "日结",
        2: "周结",
        3: "月结"
      };
      return e[row.pay] || "-";
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getOrders();
    },
    getOrders: function getOrders() {
      var _this = this;

      var para = {
        page: this.page,
        book: 1
      };
      this.listLoading = true;
      _nprogress2.default.start();
      _api.orderApi.list(para).then(function (res) {
        _this.total = res.data.count;
        res.data.rows.forEach(function (row) {
          row.price = row.price / 100;
          row.floorPrice = row.floorPrice / 100;
          row.discount = row.discount / 100;
          row.commission = row.commission / 100;
        });
        _this.orders = res.data.rows;
        _this.listLoading = false;
        _nprogress2.default.done();
      });
    },
    createOrders: function createOrders() {
      this.addFormVisible = true;
    },
    getOrderStatus: function getOrderStatus(row) {
      var map = row.from == 1 ? _constant.tzOrderStatusMap : {};
      return map[row.orderStatus] || row.orderStatus;
    },
    getHandleStatus: function getHandleStatus(row) {
      return !!row.handleStatus ? _constant.handleStatusMap[row.handleStatus] || "未处理" : "未处理";
    },

    handleEdit: function handleEdit(index, row) {
      this.editFormVisible = true;
      this.editForm = (0, _assign2.default)(this.editForm, row);
      if (!this.editForm.pay && this.hotelMap[row.hotel_id] && this.hotelMap[row.hotel_id].pay) {
        this.editForm.pay = this.hotelMap[row.hotel_id].pay;
      }
    },

    editSubmit: function editSubmit() {
      var _this2 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          if (!_this2.editForm.cancel) {
            if (!_this2.editForm.hotel_id) {
              return _this2.$message.error("请先选择酒店");
            }
            if (!_this2.editForm.price) {
              return _this2.$message.error("请设置订单价格");
            }
          }
          _this2.$confirm("确认提交吗？", "提示", {}).then(function () {
            _this2.editLoading = true;

            var para = (0, _assign2.default)({ judgeHandleStatus: 1 }, _this2.editForm, {
              handleStatus: "0" });
            _api.orderApi.update(para).then(function (res) {
              _this2.editLoading = false;

              _this2.$message({
                message: "提交成功",
                type: "success"
              });
              _this2.$refs["editForm"].resetFields();
              _this2.editFormVisible = false;

              _this2.getOrders();
            });
          }).finally(function (_) {
            _this2.editLoading = false;
          });
        }
      });
    },

    addSubmit: function addSubmit() {
      var _this3 = this;

      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this3.$confirm("确认提交吗？", "提示", {}).then(function () {
            _this3.addLoading = true;

            _this3.addForm.checkInDate = _this3.addForm.dates[0];
            _this3.addForm.checkOutDate = _this3.addForm.dates[1];
            var para = (0, _assign2.default)({}, _this3.addForm);
            _api.orderApi.createOrder(para).then(function (res) {
              _this3.addLoading = false;

              _this3.$message({
                message: "提交成功",
                type: "success"
              });
              _this3.$refs["addForm"].resetFields();
              _this3.addFormVisible = false;
              _this3.addForm = (0, _assign2.default)({}, defaultAddform);
              _this3.getOrders();
            });
          });
        }
      });
    },
    selsChange: function selsChange(sels) {
      this.sels = sels;
    },

    batchRemove: function batchRemove() {
      var _this4 = this;

      var ids = this.sels.map(function (item) {
        return item.id;
      }).toString();
      this.$confirm("确认删除选中记录吗？", "提示", {
        type: "warning"
      }).then(function () {
        _this4.listLoading = true;

        var para = { ids: ids };
        batchRemoveUser(para).then(function (res) {
          _this4.listLoading = false;

          _this4.$message({
            message: "删除成功",
            type: "success"
          });
          _this4.getOrders();
        });
      }).catch(function () {});
    },
    getHotelMap: function getHotelMap() {
      var _this5 = this;

      _api.hotelApi.listMap().then(function (_ref) {
        var data = _ref.data;

        _this5.hotelMap = data;
        _this5.hotels = (0, _entries2.default)(data);
      });
    }
  },
  created: function created() {
    this.fecha = _fecha2.default;
  },
  mounted: function mounted() {
    this.getHotelMap();
    this.getOrders();
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(["getUserInfo", "isSuperAdmin"]))
};

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(76);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(75);

var _assign2 = _interopRequireDefault(_assign);

var _entries = __webpack_require__(149);

var _entries2 = _interopRequireDefault(_entries);

var _toConsumableArray2 = __webpack_require__(313);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _util = __webpack_require__(101);

var _util2 = _interopRequireDefault(_util);

var _nprogress = __webpack_require__(97);

var _nprogress2 = _interopRequireDefault(_nprogress);

var _api = __webpack_require__(59);

var _vuex = __webpack_require__(100);

var _fecha = __webpack_require__(174);

var _fecha2 = _interopRequireDefault(_fecha);

var _constant = __webpack_require__(102);

var _xlsx = __webpack_require__(443);

var _xlsx2 = _interopRequireDefault(_xlsx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      fromMap: _constant.fromMap,
      fromNameMap: _constant.fromNameMap,
      tzOrderStatusMap: _constant.tzOrderStatusMap,
      handleStatusMap: _constant.handleStatusMap,
      stausMap: {},
      hotelMap: {},
      hotels: [],
      search: {
        orderId: "",
        handleStatus: [],
        hotel_id: null,
        checkInRange: [],
        checkOutRange: [],
        guestName: "",
        from: '',
        pay: '',
        note: ''
      },
      totalPrice: 0,
      totalCommission: 0,
      totalRoomCount: 0,
      totalStay: 0,
      orders: [],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [],

      editFormVisible: false,
      editLoading: false,
      editFormRules: {},

      editForm: {
        note: "",
        discount: 0,
        floorPrice: 0,
        price: 0,
        id: "",
        hotel_id: "",
        handleStatus: "1",
        send: 1,
        breakfist: 0,
        pay: ''
      },
      addFormVisible: false,
      addLoading: false,
      addFormRules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },

      addForm: {
        name: "",
        password: "",
        role: 1
      }
    };
  },

  methods: {
    formatRole: function formatRole(row, column) {
      return row.role == 0 ? "超级管理员" : "普通管理员";
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getOrders();
    },
    getExcel: function getExcel() {
      this.getOrders(1);
    },
    getOrders: function getOrders() {
      var _this = this;

      var all = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var para = {
        page: this.page,
        search: this.search,
        all: all
      };
      this.listLoading = true;
      _nprogress2.default.start();
      _api.orderApi.list(para).then(function (res) {
        res.data.rows.forEach(function (row) {
          row.price = row.price / 100;
          row.floorPrice = row.floorPrice / 100;
          row.discount = row.discount / 100;
          row.commission = row.commission / 100;
        });
        if (all != "1") {
          _this.total = res.data.count;
          _this.orders = res.data.rows;
          _this.totalPrice = res.data.totalPrice / 100;
          _this.totalCommission = res.data.totalCommission / 100;
          _this.totalStay = res.data.totalStay;
          _this.totalRoomCount = res.data.totalRoomCount;
        } else {
          var firstLine = ["客户名", "房型", "入住日期", "离店日期", "晚", "间", "价格", "原价", "立减", "利润", "渠道", "处理状态", "酒店名", "备注"];
          var datas = res.data.rows.map(function (_ref) {
            var checkInDate = _ref.checkInDate,
                checkOutDate = _ref.checkOutDate,
                goodsName = _ref.goodsName,
                guestName = _ref.guestName,
                stay = _ref.stay,
                roomCount = _ref.roomCount,
                price = _ref.price,
                floorPrice = _ref.floorPrice,
                discount = _ref.discount,
                commission = _ref.commission,
                from = _ref.from,
                handleStatus = _ref.handleStatus,
                hotel_id = _ref.hotel_id,
                note = _ref.note,
                orderId = _ref.orderId;

            console.log("orderid", orderId);
            return [guestName, goodsName, _fecha2.default.format(new Date(checkInDate), "YYYY-MM-DD"), _fecha2.default.format(new Date(checkOutDate), "YYYY-MM-DD"), stay, roomCount, price, floorPrice, discount, commission, from == 1 ? "同舟" : "代理通", !!handleStatus ? _constant.handleStatusMap[handleStatus] || "未处理" : "未处理", from == 1 ? _this.hotelMap[hotel_id] && _this.hotelMap[hotel_id].tzName || "-" : _this.hotelMap[hotel_id] && _this.hotelMap[hotel_id].dltName || "-", ""];
          });
          var filename = "\u8BA2\u5355.xlsx";
          var data = [firstLine].concat((0, _toConsumableArray3.default)(datas));
          var ws_name = "Sheet1";
          var wb = _xlsx2.default.utils.book_new(),
              ws = _xlsx2.default.utils.aoa_to_sheet(data);
          _xlsx2.default.utils.book_append_sheet(wb, ws, ws_name);
          _xlsx2.default.writeFile(wb, filename);
        }
        _nprogress2.default.done();
        _this.listLoading = false;
      });
    },
    getOrderStatus: function getOrderStatus(row) {
      var map = row.from == 1 ? _constant.tzOrderStatusMap : {};
      return map[row.orderStatus] || row.orderStatus;
    },
    getHandleStatus: function getHandleStatus(row) {
      return !!row.handleStatus ? _constant.handleStatusMap[row.handleStatus] || "未处理" : "未处理";
    },
    getSettleStatus: function getSettleStatus(row) {
      if (!row.settle) {
        return "未提出申请";
      }
      switch (row.settle) {
        case 1:
          return "已提出结算申请，等待处理";
        case 2:
          return "已处理";
      }
    },
    getPay: function getPay(row) {
      var e = {
        1: '日结',
        2: '周结',
        3: '月结'
      };
      return e[row.pay] || '-';
    },
    getSettleTime: function getSettleTime(row) {
      if (!row.settleTime) return "-";
      return _fecha2.default.format(new Date(row.settleTime), "YYYY-MM-DD");
    },

    handleSend: function handleSend(index, row) {
      var _this2 = this;

      _nprogress2.default.start();
      if (!row.hotel_id) {
        return this.$message.error("请先设置该订单的酒店");
      }
      if (!row.price) {
        return this.$message.error("请先设置该订单价格");
      }
      var para = { id: row.id };
      _api.orderApi.send(para).then(function (res) {
        _this2.listLoading = false;
        _nprogress2.default.done();
        _this2.$message({
          message: "发送成功",
          type: "success"
        });
      }).finally(function (_) {
        _this2.listLoading = false;
      });
    },

    handleEdit: function handleEdit(index, row) {
      this.editFormVisible = true;
      console.log((0, _entries2.default)(_constant.handleStatusMap), row);
      this.editForm = (0, _assign2.default)(this.editForm, row);
      this.editForm.handleStatus = "" + this.editForm.handleStatus;
    },
    handleDel: function handleDel(id) {
      var _this3 = this;

      this.$confirm("确认删除吗？", "提示", {}).then(function () {
        _api.orderApi.delete(id).then(function (res) {
          _this3.$message({
            message: "提交成功",
            type: "success"
          });
          _this3.getOrders();
        });
      });
    },

    editSubmit: function editSubmit() {
      var _this4 = this;

      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          if (!_this4.editForm.price) {
            return _this4.$message.error("请设置订单价格");
          }
          _this4.$confirm("确认提交吗？", "提示", {}).then(function () {
            _this4.editLoading = true;

            var para = (0, _assign2.default)({}, _this4.editForm);
            if (!para.price) {
              return _this4.$message.error("请先设置该订单价格");
            }

            _api.orderApi.update(para).then(function (res) {
              _this4.editLoading = false;

              _this4.$message({
                message: "提交成功",
                type: "success"
              });
              _this4.$refs["editForm"].resetFields();
              _this4.editFormVisible = false;

              _this4.getOrders();
            });
          }).finally(function (_) {
            _this4.editLoading = false;
          });
        }
      });
    },

    addSubmit: function addSubmit() {
      var _this5 = this;

      console.log(this.addForm);
      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this5.$confirm("确认提交吗？", "提示", {}).then(function () {
            _this5.addLoading = true;

            var para = (0, _assign2.default)({}, _this5.addForm);

            _api.adminApi.add(para).then(function (res) {
              _this5.addLoading = false;

              _this5.$message({
                message: "提交成功",
                type: "success"
              });
              _this5.$refs["addForm"].resetFields();
              _this5.addFormVisible = false;
              _this5.getOrders();
            });
          });
        }
      });
    },
    selsChange: function selsChange(sels) {
      this.sels = sels;
    },

    batchRemove: function batchRemove() {
      var _this6 = this;

      var ids = this.sels.map(function (item) {
        return item.id;
      }).toString();
      this.$confirm("确认删除选中记录吗？", "提示", {
        type: "warning"
      }).then(function () {
        _this6.listLoading = true;

        var para = { ids: ids };
        batchRemoveUser(para).then(function (res) {
          _this6.listLoading = false;

          _this6.$message({
            message: "删除成功",
            type: "success"
          });
          _this6.getOrders();
        });
      }).catch(function () {});
    },
    getHotelMap: function getHotelMap() {
      var _this7 = this;

      _api.hotelApi.listMap().then(function (_ref2) {
        var data = _ref2.data;

        _this7.hotelMap = data;
        _this7.hotels = (0, _entries2.default)(data);
        window.vm = _this7;
      });
    }
  },
  created: function created() {
    this.fecha = _fecha2.default;
  },
  mounted: function mounted() {
    this.getHotelMap();
    this.getOrders();
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(["getUserInfo", "isSuperAdmin"]))
};

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(76);

var _extends3 = _interopRequireDefault(_extends2);

var _entries = __webpack_require__(149);

var _entries2 = _interopRequireDefault(_entries);

var _assign = __webpack_require__(75);

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = __webpack_require__(313);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _util = __webpack_require__(101);

var _util2 = _interopRequireDefault(_util);

var _nprogress = __webpack_require__(97);

var _nprogress2 = _interopRequireDefault(_nprogress);

var _api = __webpack_require__(59);

var _vuex = __webpack_require__(100);

var _fecha = __webpack_require__(174);

var _fecha2 = _interopRequireDefault(_fecha);

var _xlsx = __webpack_require__(443);

var _xlsx2 = _interopRequireDefault(_xlsx);

var _constant = __webpack_require__(102);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      type: 0,
      clerkRow: [],
      stausMap: {},
      hotelMap: {},
      hotels: [],
      filters: {
        name: ""
      },
      orders: [],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [],

      editFormVisible: false,
      editLoading: false,
      editFormRules: {},

      editForm: {
        auditAmount: 0,
        auditStatus: 2,
        auditDetail: ""
      },

      addFormVisible: false,
      addLoading: false,
      addFormRules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },

      addForm: {
        name: "",
        password: "",
        role: 1
      }
    };
  },

  methods: {
    formatRole: function formatRole(row, column) {
      return row.role == 0 ? "超级管理员" : "普通管理员";
    },
    formatSettleTime: function formatSettleTime(row) {
      return row.settleTime ? _fecha2.default.format(new Date(row.settleTime), "YYYY-MM-DD HH:mm:SS") : "-";
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getSettles();
    },
    getSettles: function getSettles() {
      var _this = this;

      var para = {
        page: this.page,
        type: this.type
      };
      this.listLoading = true;
      _nprogress2.default.start();
      _api.orderApi.settleList(para).then(function (res) {
        _this.total = res.data.count;
        res.data.rows.forEach(function (row) {
          var clerk = _this.clerkRow.find(function (i) {
            return i.open_id === row.creator;
          });
          clerk && (row.creator = clerk.name);
          typeof row.amount === "number" && (row.amount = row.amount / 100);
          typeof row.auditAmount === "number" && (row.auditAmount = row.auditAmount / 100);
        });
        _this.orders = res.data.rows;
        _this.listLoading = false;
        _nprogress2.default.done();
      });
    },
    getHandleStatus: function getHandleStatus(row) {
      return !!row.handleStatus ? _constant.handleStatusMap[row.handleStatus] || "未处理" : "未处理";
    },
    handleExcel: function handleExcel(index, row) {
      var _this2 = this;

      _api.orderApi.settlingOrder({ id: row.id }).then(function (res) {
        if (!res.code) {
          var rows = res.data;
          var firstLine = ["客户名", "房型", "入住日期", "离店日期", "晚", "间", "价格", "备注"];
          var datas = rows.map(function (_ref) {
            var checkInDate = _ref.checkInDate,
                checkOutDate = _ref.checkOutDate,
                goodsName = _ref.goodsName,
                guestName = _ref.guestName,
                stay = _ref.stay,
                roomCount = _ref.roomCount,
                price = _ref.price,
                note = _ref.note;
            return [guestName, goodsName, _fecha2.default.format(new Date(checkInDate), "YYYY-MM-DD"), _fecha2.default.format(new Date(checkOutDate), "YYYY-MM-DD"), stay, roomCount, price / 100, ""];
          });
          var filename = "\u7ED3\u7B97" + row.id + ".xlsx";
          var data = [firstLine].concat((0, _toConsumableArray3.default)(datas));
          var ws_name = "Sheet1";
          var wb = _xlsx2.default.utils.book_new(),
              ws = _xlsx2.default.utils.aoa_to_sheet(data);
          _xlsx2.default.utils.book_append_sheet(wb, ws, ws_name);
          _xlsx2.default.writeFile(wb, filename);
        }
      }).catch(function (e) {
        _this2.$message.error(e.message);
      });
    },
    getSettleStatus: function getSettleStatus(row) {
      return _constant.settleMap[row.auditStatus];
    },

    handleEdit: function handleEdit(index, row) {
      this.editFormVisible = true;
      this.editForm.id = row.id;
    },

    editSubmit: function editSubmit() {
      var _this3 = this;

      if (this.editForm.auditStatus == 2 && this.editForm.auditAmount == "0") {
        return this.$message.error("请确认审批金额");
      }
      this.$refs.editForm.validate(function (valid) {
        if (valid) {
          _this3.$confirm("确认提交吗？", "提示", {}).then(function () {
            _this3.editLoading = true;

            var para = (0, _assign2.default)({}, _this3.editForm);
            _api.orderApi.settle(para).then(function (res) {
              _this3.editLoading = false;

              _this3.$message({
                message: "提交成功",
                type: "success"
              });
              _this3.$refs["editForm"].resetFields();
              _this3.editFormVisible = false;
              _this3.getSettles();
            });
          }).finally(function (_) {
            _this3.editLoading = false;
          });
        }
      });
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },

    batchRemove: function batchRemove() {
      var _this4 = this;

      var ids = this.sels.map(function (item) {
        return item.id;
      }).toString();
      this.$confirm("确认删除选中记录吗？", "提示", {
        type: "warning"
      }).then(function () {
        _this4.listLoading = true;

        var para = { ids: ids };
        batchRemoveUser(para).then(function (res) {
          _this4.listLoading = false;

          _this4.$message({
            message: "删除成功",
            type: "success"
          });
          _this4.getSettles();
        });
      }).catch(function () {});
    },
    getHotelMap: function getHotelMap() {
      var _this5 = this;

      _api.hotelApi.listMap().then(function (_ref2) {
        var data = _ref2.data;

        _this5.hotelMap = data;
        _this5.hotels = (0, _entries2.default)(data);
      });
    },
    getClerkMap: function getClerkMap() {
      var _this6 = this;

      _api.auditApi.list({
        all: 1
      }).then(function (_ref3) {
        var rows = _ref3.data.rows;

        _this6.clerkRow = rows;
      });
    }
  },
  created: function created() {
    this.fecha = _fecha2.default;
    this.getHotelMap();
    this.getClerkMap();
  },
  mounted: function mounted() {
    this.getSettles();
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(["getUserInfo", "isSuperAdmin"]))
};

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(76);

var _extends3 = _interopRequireDefault(_extends2);

var _entries = __webpack_require__(149);

var _entries2 = _interopRequireDefault(_entries);

var _assign = __webpack_require__(75);

var _assign2 = _interopRequireDefault(_assign);

var _util = __webpack_require__(101);

var _util2 = _interopRequireDefault(_util);

var _nprogress = __webpack_require__(97);

var _nprogress2 = _interopRequireDefault(_nprogress);

var _api = __webpack_require__(59);

var _vuex = __webpack_require__(100);

var _fecha = __webpack_require__(174);

var _fecha2 = _interopRequireDefault(_fecha);

var _constant = __webpack_require__(102);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      activeTab: 'date',
      fromMap: _constant.fromMap,
      fromNameMap: _constant.fromNameMap,
      search: {
        checkInRange: [new Date(), new Date()]
      },
      stausMap: {},
      hotelMap: {},
      hotels: [],
      filters: {
        name: ""
      },
      orders: [],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [],

      editFormVisible: false,
      editLoading: false,
      editFormRules: {},

      editForm: {
        note: "",
        discount: 0,
        floorPrice: 0,
        price: 0,
        id: "",
        hotel_id: ""
      },

      addFormVisible: false,
      addLoading: false,
      addFormRules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },

      addForm: {
        name: "",
        password: "",
        role: 1
      }
    };
  },

  methods: {
    formatRole: function formatRole(row, column) {
      return row.role == 0 ? "超级管理员" : "普通管理员";
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getOrders();
    },
    getOrders: function getOrders() {
      var _this = this;

      var para = {
        page: this.page,
        search: this.search,
        type: this.activeTab
      };
      if (!this.search.checkInRange || !this.search.checkInRange[0]) {
        para.search.checkInRange = [];
      }
      this.listLoading = true;
      _nprogress2.default.start();
      _api.orderApi.statistics(para).then(function (res) {
        _this.total = res.data.count;
        res.data.rows.forEach(function (row) {
          row.price = row.price / 100;

          row.commission = row.commission / 100;
        });
        _this.orders = res.data.rows;
      }).finally(function (_) {
        _nprogress2.default.done();
        _this.listLoading = false;
      });
    },
    getOrderStatus: function getOrderStatus(row) {
      var map = row.from == 1 ? _constant.tzOrderStatusMap : {};
      return map[row.orderStatus] || row.orderStatus;
    },

    handleEdit: function handleEdit(index, row) {
      this.editFormVisible = true;
      this.editForm = (0, _assign2.default)(this.editForm, row);
    },

    selsChange: function selsChange(sels) {
      this.sels = sels;
    },
    getHotelMap: function getHotelMap() {
      var _this2 = this;

      _api.hotelApi.listMap().then(function (_ref) {
        var data = _ref.data;

        _this2.hotelMap = data;
        _this2.hotels = (0, _entries2.default)(data);
      });
    },
    onTabChange: function onTabChange(tab) {
      this.activeTab = tab.name;
      this.getOrders();
    }
  },
  created: function created() {
    this.fecha = _fecha2.default;
  },
  mounted: function mounted() {
    this.getHotelMap();
    this.getOrders();
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(["getUserInfo", "isSuperAdmin"]))
};

/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(76);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(535);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(75);

var _assign2 = _interopRequireDefault(_assign);

var _entries = __webpack_require__(149);

var _entries2 = _interopRequireDefault(_entries);

var _fecha = __webpack_require__(174);

var _fecha2 = _interopRequireDefault(_fecha);

var _api = __webpack_require__(59);

var _constant = __webpack_require__(102);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      search: {
        hotel_id: "",
        range: [],
        name: '',
        breakfirst: ''
      },
      hotels: [],
      hotelMap: {},
      fromNameMap: _constant.fromNameMap,
      addFormVisible: false,
      editFormVisible: false,
      addLoading: false,
      editLoading: false,
      tableType: 1,
      listRes: {},
      addForm: {
        hotel_id: "",
        range: [],
        name: "",
        price: 0,
        breakfirst: 0,
        weekdays: [0, 1, 2, 3, 4, 5, 6]
      },
      editForm: {
        hotel_id: "",
        date: "",
        name: "",
        price: 0,
        breakfirst: 0
      },
      page: 1,
      total: 0,
      listLoading: false,
      tpls: [],
      pickerOptions: {
        shortcuts: [{
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      batchDeleteVisible: false,
      batchEditVisible: false,
      batchDeleteForm: {
        hotel_id: "",
        range: [],
        name: "",
        price: '',
        breakfirst: 0,
        weekdays: [0, 1, 2, 3, 4, 5, 6]
      },
      batchEditForm: {
        hotel_id: "",
        range: [],
        name: "",
        price: '',
        breakfirst: 0,
        weekdays: [0, 1, 2, 3, 4, 5, 6]
      }
    };
  },


  methods: {
    getHotelMap: function getHotelMap() {
      var _this = this;

      _api.hotelApi.listMap().then(function (_ref) {
        var data = _ref.data;

        _this.hotelMap = data;
        _this.hotels = (0, _entries2.default)(data);
      });
    },
    handleAdd: function handleAdd() {
      this.addForm = {
        hotel_id: "",
        range: [],
        name: "",
        price: 0,
        breakfirst: 0,
        weekdays: [0, 1, 2, 3, 4, 5, 6]
      };
      this.addLoading = false;
      this.addFormVisible = true;
    },
    handleDel: function handleDel(id) {
      var _this2 = this;

      this.$confirm("确认删除吗？", "提示", {}).then(function () {
        _api.orderApi.tplDelete(id).then(function (res) {
          _this2.$message({
            message: "提交成功",
            type: "success"
          });
          _this2.getTpls();
        });
      });
    },

    handleEdit: function handleEdit(index, row) {
      this.editFormVisible = true;
      this.editForm = (0, _assign2.default)(this.editForm, row);
    },
    addSubmit: function addSubmit() {
      var _this3 = this;

      this.addLoading = true;
      _api.orderApi.tplAdd(this.addForm).then(function (res) {
        _this3.$message({
          message: "创建成功",
          type: "success"
        });
        _this3.addLoading = false;
        _this3.addFormVisible = false;
        _this3.getTpls();
      }).catch(function () {
        _this3.addLoading = false;
      });
    },
    batchDeleteSubmit: function batchDeleteSubmit() {
      var _this4 = this;

      _api.orderApi.check(this.batchDeleteForm).then(function (res) {
        if (res.data.length > 0) {
          _this4.$confirm("\u627E\u5230" + res.data.length + "\u6761\u6570\u636E\uFF0C\u786E\u8BA4\u5220\u9664\u5417", "提示", {
            type: "warning"
          }).then(function () {
            _api.orderApi.batchDelete({ ids: res.data.map(function (i) {
                return i.id;
              }) }).then(function (res) {
              if (res.code === 0) {
                _this4.$message.success('删除成功');
                _this4.batchDeleteVisible = false;
                _this4.getTpls();
              }
            });
          });
        } else {
          _this4.$message.error("没有找到数据");
        }
      });
    },
    handleBatchDel: function handleBatchDel() {
      this.batchDeleteForm = {
        hotel_id: "",
        range: [],
        name: "",
        price: '',
        breakfirst: 0,
        weekdays: [0, 1, 2, 3, 4, 5, 6]
      };
      this.batchDeleteVisible = true;
    },
    editSubmit: function editSubmit() {
      var _this5 = this;

      this.editLoading = true;
      _api.orderApi.tplUpdate({
        id: this.editForm.id,
        price: this.editForm.price,
        breakfirst: this.editForm.breakfirst,
        name: this.editForm.name
      }).then(function (r) {
        _this5.$message({
          message: "修改成功",
          type: "success"
        });
        _this5.editLoading = false;
        _this5.editFormVisible = false;
        _this5.getTpls();
      }).catch(function (e) {
        _this5.editLoading = false;
        _this5.$message({
          message: e.message,
          type: "error"
        });
      });
    },
    getTpls: function getTpls() {
      var _this6 = this;

      this.listLoading = true;
      var para = {
        page: this.page,
        search: this.search
      };
      _api.orderApi.tplList(para).then(function (res) {
        _this6.listLoading = false;
        _this6.total = res.data.count;
        if (res.data.rows) {
          _this6.tableType = 1;
          res.data.rows.forEach(function (i) {
            return i.price = i.price / 100;
          });
          _this6.tpls = res.data.rows;
        } else {
          _this6.tableType = 2;
          (0, _keys2.default)(res.data).forEach(function (key) {
            res.data[key].forEach(function (ii) {
              return ii.price = ii.price / 100;
            });
          });
          _this6.listRes = res.data;
        }
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getTpls();
    },
    formatDate: function formatDate(row) {
      return row.tpl_date ? _fecha2.default.format(new Date(row.tpl_date), "YYYY-MM-DD") : "-";
    },
    handleBatchEdit: function handleBatchEdit() {
      this.batchEditForm = {
        hotel_id: "",
        range: [],
        name: "",
        price: '',
        breakfirst: 0,
        weekdays: [0, 1, 2, 3, 4, 5, 6]
      };
      this.batchEditVisible = true;
    },
    batchEditSubmit: function batchEditSubmit() {
      var _this7 = this;

      if (this.batchEditForm.price <= 0) {
        return this.$message.error('价格要大于0');
      }
      _api.orderApi.check((0, _extends3.default)({}, this.batchEditForm, { ignorePrice: true })).then(function (res) {
        if (res.data.length > 0) {
          _this7.$confirm("\u627E\u5230" + res.data.length + "\u6761\u6570\u636E\uFF0C\u786E\u8BA4\u4FEE\u6539\u4EF7\u683C\u4E3A" + _this7.batchEditForm.price, "提示", {
            type: "warning"
          }).then(function () {
            _api.orderApi.batchEdit({ ids: res.data.map(function (i) {
                return i.id;
              }), price: _this7.batchEditForm.price }).then(function (res) {
              if (res.code === 0) {
                _this7.$message.success('修改成功');
                _this7.batchEditVisible = false;
                _this7.getTpls();
              }
            });
          });
        } else {
          _this7.$message.error("没有找到数据");
        }
      });
    }
  },
  mounted: function mounted() {
    this.getHotelMap();
    this.getTpls();
  }
};

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(539);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(538);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _querystring = __webpack_require__(440);

var _querystring2 = _interopRequireDefault(_querystring);

var _api = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parseParam = function parseParam(_) {
  var search = window.location.href.split("?")[1];
  if (!search) return {};
  return _querystring2.default.parse(search);
};
var appid = "wx6d40876f621b822b";

exports.default = {
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
      var code, force, res, next;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              code = parseParam().code;
              force = parseParam().force;

              if (!code) {
                _context.next = 14;
                break;
              }

              _context.prev = 3;
              _context.next = 6;
              return (0, _api.wxLogin)(code);

            case 6:
              res = _context.sent;

              if (!res.code) {
                next = parseParam().next || encodeURIComponent(location.protocol + "//" + location.host + "/book");

                location.href = decodeURIComponent(next);
              } else {
                alert("微信登录失败");
              }
              _context.next = 12;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);

            case 12:
              _context.next = 15;
              break;

            case 14:
              window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + encodeURIComponent(window.location.href) + "&response_type=code&scope=snsapi_base#wechat_redirect";

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 10]]);
    }))();
  }
};

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _babelPolyfill = __webpack_require__(470);

var _babelPolyfill2 = _interopRequireDefault(_babelPolyfill);

var _vue = __webpack_require__(49);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(474);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(305);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(471);

var _vueRouter = __webpack_require__(475);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(469);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(100);

var _vuex2 = _interopRequireDefault(_vuex);

var _routes = __webpack_require__(468);

var _routes2 = _interopRequireDefault(_routes);

__webpack_require__(472);

var _jsCookie = __webpack_require__(473);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_elementUi2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuex2.default);


var router = new _vueRouter2.default({
  routes: _routes2.default,
  mode: "history"
});

router.beforeEach(function (to, from, next) {
  if (to.path == "/login") {
    _jsCookie2.default.set("user_info", "", { path: "/", domain: "yongtengyc.com" });
    _jsCookie2.default.set("user_info.sig", "", { path: "/", domain: "yongtengyc.com" });
  }
  var user = void 0;
  try {
    user = JSON.parse(decodeURI(_jsCookie2.default.get("user_info")));
    _store2.default.dispatch("setUserInfo", user);
  } catch (e) {
    console.log("e", e);
  }

  if (~navigator.userAgent.indexOf("MicroMessenger")) {
    next();
  } else {
    if (!user && to.path != "/login") {
      next({ path: "/login" });
    } else {
      next();
    }
  }
});

new _vue2.default({
  router: router,
  store: _store2.default,

  render: function render(h) {
    return h(_App2.default);
  }
}).$mount("#app");

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  actions: {
    setUserInfo: function setUserInfo(_ref, info) {
      var commit = _ref.commit;

      commit('SETUSERINFO', info);
    }
  },
  mutations: {
    SETUSERINFO: function SETUSERINFO(state, info) {
      state.userInfo = info;
    }
  }
};

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  getUserInfo: function getUserInfo(state) {
    return state.userInfo;
  },
  isSuperAdmin: function isSuperAdmin(state) {
    return state.userInfo && state.userInfo.role === 0;
  }
};

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wxLogin = exports.orderApi = exports.auditApi = exports.hotelApi = exports.adminApi = exports.requestLogin = undefined;

var _promise = __webpack_require__(312);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(498);

var _axios2 = _interopRequireDefault(_axios);

var _elementUi = __webpack_require__(305);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var base = '//api.yongtengyc.com/admin';

var axiosInstance = _axios2.default.create({
  baseURL: base,
  withCredentials: true
});

axiosInstance.interceptors.response.use(function (response) {
  return response.data;
}, function (error) {
  _elementUi.Message.error({
    message: error.response.data.message || error
  });
  if (error.response.status === 401) {
    if (~navigator.userAgent.indexOf('MicroMessenger')) {
      var ref = '/wechat-login?next=' + encodeURIComponent(location.href);
      location.href = ref;
    } else {
      location.href = '/login';
    }
  }
  return _promise2.default.reject(error);
});

var requestLogin = exports.requestLogin = function requestLogin(params) {
  return axiosInstance.post(base + '/login', params);
};

var adminApi = exports.adminApi = {
  list: function list(params) {
    return axiosInstance.get('/list', {
      params: params
    });
  },
  add: function add(data) {
    return axiosInstance.post('/create', data);
  },
  del: function del(data) {
    return axiosInstance.post('/delete', data);
  },
  update: function update(data) {
    return axiosInstance.post('/update', data);
  }
};

var hotelApi = exports.hotelApi = {
  list: function list(params) {
    return axiosInstance.get('/hotel/list', {
      params: params
    });
  },
  add: function add(data) {
    return axiosInstance.post('/hotel/create', data);
  },
  del: function del(data) {
    return axiosInstance.post('/hotel/delete', data);
  },
  listMap: function listMap(_) {
    return axiosInstance.get('/hotel/map');
  },
  update: function update(data) {
    return axiosInstance.post('/hotel/update', data);
  }
};

var auditApi = exports.auditApi = {
  list: function list(params) {
    return axiosInstance.get('/audit/list', {
      params: params
    });
  },
  update: function update(data) {
    return axiosInstance.post('/audit/update', data);
  },
  del: function del(data) {
    return axiosInstance.post('/audit/delete', data);
  }
};

var orderApi = {
  list: function list(params) {
    return axiosInstance.get('/order/list', { params: params });
  },
  cookie: function cookie(_ref) {
    var key = _ref.key,
        _cookie = _ref.cookie;
    return axiosInstance.post('/order/update-cookie', { key: key, cookie: _cookie.replaceAll(' ', '') });
  },
  update: function update(data) {
    return axiosInstance.post('/order/update', data);
  },
  send: function send(data) {
    return axiosInstance.post('/order/send', data);
  },
  statistics: function statistics(params) {
    return axiosInstance.get('/order/statistics', { params: params });
  },
  settleList: function settleList(params) {
    return axiosInstance.get('/order/settle', { params: params });
  },
  settle: function settle(data) {
    return axiosInstance.post('/order/settle', data);
  },
  settlingOrder: function settlingOrder(params) {
    return axiosInstance.get('/order/settling-order', { params: params });
  },
  createOrder: function createOrder(data) {
    return axiosInstance.post('/order/create', data);
  },
  delete: function _delete(id) {
    return axiosInstance.post('/order/delete/' + id);
  },
  tplAdd: function tplAdd(data) {
    return axiosInstance.post('/order/tpl-add', data);
  },
  tplDelete: function tplDelete(id) {
    return axiosInstance.post('/order/tpl-delete', { id: id });
  },
  tplUpdate: function tplUpdate(data) {
    return axiosInstance.post('/order/tpl-update', data);
  },
  tplList: function tplList(params) {
    return axiosInstance.get('/order/tpl-list', { params: params });
  },
  check: function check(params) {
    return axiosInstance.post('/order/tpl-check', params);
  },
  batchDelete: function batchDelete(d) {
    return axiosInstance.post('/order/tpl-batch-delete', d);
  },
  batchEdit: function batchEdit(d) {
    return axiosInstance.post('/order/tpl-batch-edit-price', d);
  }
};

exports.orderApi = orderApi;
var wxLogin = exports.wxLogin = function wxLogin(code) {
  return axiosInstance.post('/wx-login', { code: code });
};

/***/ })

},[531]);


// WEBPACK FOOTER //
// js/app.4168a438fa665dabce39.js